import '../../assets/src/components/converter/converter/picker-layout.css';
import { openModal } from '../../assets/src/components/converter/converter/modal.js';

const root = document.querySelector('[data-roi]');
if (root) {
  root.dataset.converterNexus = root.dataset.nexus;
  const state = {
    root, base:JSON.parse(root.querySelector('[data-roi-initial]').textContent), quote:{slug:''},
    selectedSide:'base', activeTab:'all', searchTimer:0, searchController:null,
    searchRequestId:0, searchCache:new Map(), defaultCache:new Map(), dialog:null,
    imageMarkup:(source, alt) => window.ArzRoiImages.markup(root, source, alt),
    onImagesRendered:() => window.ArzRoiImages.refresh(),
  };
  root.querySelector('[data-coin-open]').addEventListener('click', () => openModal(state, 'base', asset => {
    state.base = asset;
    root.dispatchEvent(new CustomEvent('roi:asset-selected', {detail:asset}));
  }));
}
